import * as yup from 'yup';
import { yupUtils } from '../../utils/yup/utils';
import { UserPath, UserPathItem } from '../types/userPath';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, isProjectError } from '../../utils/errors';

export const UserPathItemSchema = yup.object().shape({
  order: yupUtils.numberRequired,
  title: yupUtils.stringRequired('Title is a required field'),
  collectionId: yupUtils.stringRequired('Collection ID is a required field'),
  bulletPoints: yup.array().of(yup.string()),
});

export const MinimalUserPathSchema = yup.object().shape({
  id: yupUtils.stringRequired('Document ID is a required field'),
  title: yupUtils.stringRequired('Title is a required field'),
  paths: yupUtils.arrayRequiredOf(UserPathItemSchema),
});

const parseBulletPoints = (rawBullets: any): string[] => {
  if (!(rawBullets && Array.isArray(rawBullets))) {
    return [];
  }

  return rawBullets.filter((item) => typeof item === 'string' && item.trim()).map((item) => item.trim());
};

const parsePathItems = (rawPaths: any): UserPathItem[] => {
  if (!(rawPaths && Array.isArray(rawPaths))) {
    return [];
  }

  return rawPaths
    .filter((item) => item && item.title && item.collectionId)
    .map((item) => ({
      order: typeof item.order === 'number' ? item.order : 0,
      title: item.title,
      collectionId: item.collectionId,
      bulletPoints: parseBulletPoints(item.bulletPoints),
    }))
    .sort((a, b) => a.order - b.order);
};

export const parseUserPath = async (object: any): Promise<UserPath | ProjectErrorType> => {
  try {
    if (object && object.id && object.title) {
      const userPath: UserPath = {
        id: object.id,
        title: object.title,
        paths: parsePathItems(object.paths),
      };
      return userPath;
    }
    console.log(`[USER PATHS] Invalid user path object - missing fields`);
    return getProjectErrorForCode(ProjectErrors.invalidUserPath);
  } catch (error) {
    console.log(`[USER PATHS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorForCode(ProjectErrors.invalidUserPath);
  }
};

export const parseUserPaths = async (items: any): Promise<UserPath[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[USER PATHS] Error: No array found.');
    return [];
  }

  const data: UserPath[] = [];
  for (const item of items) {
    const o = await parseUserPath(item);
    if (o && !isProjectError(o)) {
      data.push(o as UserPath);
    }
  }

  return data;
};
